document.addEventListener('DOMContentLoaded', function() {
    let btnRegister = document.querySelector('.register-newsletter');
    let inputEmail = document.querySelector('.email-newsletter');
    let emailLoader = document.querySelector('.email-loader');
    let emailMessage = document.querySelector('.email-message');
    let messageContent = document.querySelector('.message-content');
    let messageClose = document.querySelector('.message-close');
    let formLoadTime = Date.now();
    function initHoneypotFields() {
        const honeypotDiv = document.querySelector('.contact-fields');
        if (honeypotDiv) {
            const contactMailInput = document.createElement('input');
            contactMailInput.type = 'text';
            contactMailInput.name = 'ContactMailNews';
            contactMailInput.id = 'ContactMailNews';
            contactMailInput.value = '';
            honeypotDiv.appendChild(contactMailInput);
        }
    }

    function getHoneypotData() {
        const currentTime = Date.now();
        const tempExecution = currentTime - formLoadTime;

        const contactVisio = document.getElementById('ContactVisioNews');
        const tempExecutionInput = document.getElementById('TempExecutionNews');
        const contactTel = document.getElementById('ContactTelNews');
        const contactMail = document.getElementById('ContactMailNews');

        if (contactVisio) {
            contactVisio.value = 'yes';
        }
        if (tempExecutionInput) {
            tempExecutionInput.value = tempExecution.toString();
        }

        return {
            ContactTel: contactTel?.value || '',
            ContactVisio: contactVisio?.value || '',
            ContactMail: contactMail?.value || '',
            TempExecution: tempExecutionInput?.value || ''
        };
    }

    // Initialiser les champs honeypot
    initHoneypotFields();

    // Function to reset the form
    function resetForm() {
        emailMessage.classList.add('d-none');
        messageContent.classList.remove('success', 'error');
        messageContent.textContent = '';
        inputEmail.value = '';
        inputEmail.removeAttribute('disabled');
        btnRegister.removeAttribute('disabled');
    }

    // Close button handler
    messageClose.addEventListener('click', function() {
        resetForm();
    });

    btnRegister.addEventListener('click', function(e){
        e.preventDefault();
        if(!inputEmail.value) {
            return;
        }

        const honeypotData = getHoneypotData();
        // Show loader
        emailLoader.classList.remove('d-none');

        // Disable controls
        btnRegister.classList.add('loading');
        btnRegister.setAttribute('disabled', 'disabled');
        inputEmail.setAttribute('disabled', 'disabled');

        axios.post('/api/newsletter/subscribe', {
            email: inputEmail.value,
            ...honeypotData
        }).then(function(response){
            // Hide loader
            emailLoader.classList.add('d-none');

            // Remove loading state from button
            btnRegister.classList.remove('loading');

            // Set message content and style
            if(response.data.success) {
                messageContent.textContent = response.data.message;
                messageContent.classList.add('success');
            } else {
                messageContent.textContent = response.data.message;
                messageContent.classList.add('error');
            }

            // Show message
            emailMessage.classList.remove('d-none');
        }).catch(function(error) {
            let message = "Une erreur s'est produite. Veuillez réessayer.";
            if(error.response.data.message) {
                message = error.response.data.message;
            }
            // Hide loader
            emailLoader.classList.add('d-none');

            // Remove loading state from button
            btnRegister.classList.remove('loading');

            // Set error message
            messageContent.textContent = message;
            messageContent.classList.add('error');

            // Show message
            emailMessage.classList.remove('d-none');
        });
    })
});
